import React from "react";
import { useDispatch } from "react-redux";
import { Navbar, NavbarBrand, Button } from "reactstrap";
import Router from "next/router";

const Header = ({ showMobmenu }: any) => {
  const dispatch = useDispatch();

  const handleLogout = () => {
    localStorage.setItem("token", "");
    dispatch.auth.setIsNotconnected();
    Router.push("/login");
  };

  return (
    <Navbar className="navbar" dark expand="md">
      <div className="d-flex align-items-center">
        <NavbarBrand href="/" className="d-lg-none"></NavbarBrand>
        <Button
          className="btn btn-outline-secondary d-lg-none"
          onClick={showMobmenu}
        >
          <i className="bi bi-list cursor-pointer" />
        </Button>
      </div>

      <Button outline color="danger" onClick={handleLogout}>
        <i className="bi bi-box-arrow-right" /> Se déconnecter
      </Button>
    </Navbar>
  );
};

export default Header;
